import { type FC, memo, type ReactNode } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { MobileLayoutHeaderAndBanner } from "src/website-apps/responsive/stubhub-performer/components/new-mobile-layout/MobileLayoutHeaderAndBanner";
import { DesktopHeaderBanner } from "src/website-apps/responsive/stubhub-performer/components/portal/combined-header-banner/DesktopHeaderBanner";
import { PerformerViewMode } from "src/website-apps/shared/constants/performer-view-mode";
import { usePerformerViewMode } from "src/website-apps/shared/hooks/usePerformerViewMode";
import { styledBody, styledFooter } from "./PerformerLayout.styles";

interface Props {
  /** Header content */
  header: ReactNode;
  /** Body content */
  body: ReactNode;
  /** Footer content */
  footer: ReactNode;
}

/** Layout used on performer page for Mobile and Desktop Users. */
export const PerformerLayout: FC<Props> = memo(({ header, body, footer }) => {
  const isTabletBreakpoint = useMediaQuery(Breakpoint.Tablet);
  const isDesktop = useMediaQuery(Breakpoint.Desktop);
  const isMobile = !isTabletBreakpoint;
  const isTablet = isTabletBreakpoint && !isDesktop;
  const performerViewMode = usePerformerViewMode();
  const isResidency = performerViewMode === PerformerViewMode.Residency;

  return (
    <>
      {isMobile || (isTablet && !isResidency) ? (
        <MobileLayoutHeaderAndBanner header={header} />
      ) : (
        <DesktopHeaderBanner header={header} />
      )}

      <div className={styledBody}>{body}</div>

      <div className={styledFooter}>{footer}</div>
    </>
  );
});
PerformerLayout.displayName = "PerformerLayout";
